import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import { useSelector } from 'react-redux'

import { useLabel } from '../../../../hooks/useLabel'
import { getAddressFormat } from '../../../../util/addressFormats'

import PostalCodeField from './PostalCodeField'
import StateSelect from './StateSelect'

// Sem bairro, o complemento ocupa o espaço dele na linha. `label` traduz os
// rótulos (o nome do campo é a chave no dicionário)
const textFields = (hasNeighborhood, label) => [
  { name: 'street', label: label('street', 'Endereço'), lg: 6 },
  { name: 'number', label: label('number', 'Nº'), lg: 3 },
  {
    name: 'complement',
    label: label('complement', 'Complemento'),
    lg: hasNeighborhood ? 3 : 6,
  },
  ...(hasNeighborhood
    ? [{ name: 'neighborhood', label: label('neighborhood', 'Bairro'), lg: 3 }]
    : []),
  { name: 'city', label: label('city', 'Cidade'), lg: 3 },
]

// Campos de endereço do cliente, no formato do país: o da prop `country` ou, sem ela, o
// da lavanderia. onChange recebe só os campos alterados (partial); onLookup recebe o
// endereço encontrado pela busca do CEP
const AddressFields = ({ value, onChange, onBlur, onLookup, country }) => {
  const tenantCountry = useSelector(
    state => state.auth.tenantLocale?.country?.code
  )
  const format = getAddressFormat(country || tenantCountry)
  const label = useLabel()

  return (
    <>
      <Grid item sm={6} xs={12} lg={3}>
        <PostalCodeField
          value={value.cep}
          onChange={cep => onChange({ cep })}
          onLookup={onLookup}
          format={format}
        />
      </Grid>

      {textFields(format.hasNeighborhood, label).map(field => (
        <Grid item sm={6} xs={12} lg={field.lg} key={field.name}>
          <TextField
            onBlur={onBlur}
            onChange={e => onChange({ [field.name]: e.target.value })}
            label={field.label}
            fullWidth
            value={value[field.name]}
          />
        </Grid>
      ))}

      <Grid item sm={6} xs={12} lg={3}>
        <StateSelect
          value={value.uf}
          onChange={uf => onChange({ uf })}
          format={format}
        />
      </Grid>
    </>
  )
}

export default AddressFields
